module.exports = __webpack_public_path__ + "static/media/product.264d8509.png";